import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { NotFoundPage } from '@/components/NotFoundPage';
import { NotificationsPage } from '@/features/notifications/NotificationsPage';
import { ContractsPage } from '@/features/contracts/ContractsPage';
import { TicketsPage } from '@/features/tickets/TicketsPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { ContractConsumptionPage } from '@/features/reports/ContractConsumptionPage';
import { ContractPortfolioPage } from '@/features/reports/ContractPortfolioPage';
import { ResourceAllocationPage } from '@/features/reports/ResourceAllocationPage';
import { UsersPage } from '@/features/users/UsersPage';
import { GroupsPage } from '@/features/groups/GroupsPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { MonthlyConsumptionPage } from '@/features/monthlyConsumption/MonthlyConsumptionPage';
import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from '@/features/auth/ResetPasswordPage';
import { MePage } from '@/features/me/MePage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="monthly-consumptions" element={<MonthlyConsumptionPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="reports/contract-consumption" element={<ContractConsumptionPage />} />
        <Route path="reports/contract-portfolio" element={<ContractPortfolioPage />} />
        <Route path="reports/resource-allocation" element={<ResourceAllocationPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="groups" element={<GroupsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="me" element={<MePage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
